import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss']
})
export class SpinnerComponent implements OnInit {

  @Input() size: 'small' | 'medium' | 'large' = 'small';
  @Input() direction: 'row' | 'column' = 'column';
  @Input() message: string;
  @Input() messageSize: 'small' | 'medium' | 'large';
  @Input() messageColor: string = "black";

  constructor() { }

  ngOnInit(): void {
    if (!this.messageSize) this.messageSize = this.size;
  }

}
